import { call, all }  from 'redux-saga/effects';
import getUserInfo    from './get_user_info';
import getQuizInfo    from './get_quiz_info';
import submitForm     from './submit_form';


export default function* indexSaga(){
  yield all([
    call(getUserInfo),
    call(getQuizInfo),
    call(submitForm)
  ])
}